import { render, staticRenderFns } from "./searchSkrg.vue?vue&type=template&id=7876454c&scoped=true"
import script from "./searchSkrg.vue?vue&type=script&lang=js"
export * from "./searchSkrg.vue?vue&type=script&lang=js"
import style0 from "./searchSkrg.vue?vue&type=style&index=0&id=7876454c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7876454c",
  null
  
)

export default component.exports